module.exports = __webpack_public_path__ + "img/捐赠证书.33be625b.jpg";